import React, { ComponentType } from 'react';
import { Redirect, Switch, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';

import { RouteWhenAuthenticated } from 'common/components';
import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';
import { ExperienceUserManagement } from 'modules/access-control/ExperienceUserManagement';
import { ExperienceBestOfWolt } from 'modules/best-of-wolt/feature/ExperienceBestOfWolt';
import { ExperienceCampaigns } from 'modules/campaigns/ExperienceCampaigns';
import { useBusinessNavigationItems } from 'modules/experience/hooks/useBusinessNavigationItems';
import { useVenueNavigationItems } from 'modules/experience/hooks/useVenueNavigationItems';
import { useExperienceModuleContext } from 'modules/experience-core';
import { NavigationKey } from 'modules/experience-core';
import ExperienceInsights from 'modules/insights-v2/feature/ExperienceInsights';
import ExperiencePurchases from 'modules/purchases/ExperiencePurchases';
import { ExperienceTranslation } from 'modules/translation/ExperienceTranslation';
import { ExperienceBusinessDetails } from 'modules/venue/components/ExperienceBusinessDetails';

const ContentContainer = styled.main<{ isSidebarOpen: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100vh;
  overflow: auto;
  -webkit-overflow-scrolling: touch;

  @media (max-width: ${MOBILE_BREAKPOINT + 1}px) {
    overflow: ${({ isSidebarOpen }) => (isSidebarOpen ? 'hidden' : 'auto')};
  }
`;

const ViewPort = styled.div<{ isSidebarOpen: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100vh;

  @media (max-width: ${MOBILE_BREAKPOINT + 1}px) {
    width: ${({ isSidebarOpen }) => (isSidebarOpen ? '100vw' : 'auto')};
  }
`;

const ModulesMapping: Record<NavigationKey, ComponentType> = {
  [NavigationKey.INSIGHTS]: ExperienceInsights,
  [NavigationKey.BEST_OF_WOLT]: ExperienceBestOfWolt,
  [NavigationKey.ACCESS_MANAGEMENT]: ExperienceUserManagement,
  [NavigationKey.BUSINESS_DETAILS]: ExperienceBusinessDetails,
  [NavigationKey.PURCHASES]: ExperiencePurchases,
  [NavigationKey.TRANSLATION]: ExperienceTranslation,
  [NavigationKey.CAMPAIGNS]: ExperienceCampaigns,
};

export const Content = () => {
  const { isSidebarOpen } = useExperienceModuleContext();
  const businessNavigationItems = useBusinessNavigationItems();
  const venueNavigationItems = useVenueNavigationItems();
  const { url: baseUrl } = useRouteMatch();

  const allNavigationItems = [...businessNavigationItems, ...venueNavigationItems];
  const [firstNavigationItem] = allNavigationItems;

  return (
    <ContentContainer isSidebarOpen={isSidebarOpen}>
      <ViewPort isSidebarOpen={isSidebarOpen}>
        <Switch>
          {allNavigationItems.map(item => (
            <RouteWhenAuthenticated
              key={item.key}
              path={`${baseUrl}${item.link}`}
              component={ModulesMapping[item.key]}
            />
          ))}
          <Redirect exact from="" to={`${baseUrl}${firstNavigationItem.link}`} />
        </Switch>
      </ViewPort>
    </ContentContainer>
  );
};
